module.exports = __webpack_public_path__ + "static/media/youtubeImg.9e1bab40.svg";